import { Text, TextProps } from "@chakra-ui/react";
import * as React from "react";

import { DateInput, formatDayTime, formatDayTimeWithZone } from "../lib/format";
import { Tooltip } from "./tooltip";

interface UtcTimestampProps extends TextProps {
  date: DateInput | null;
}

// The agent's day rolls over at UTC midnight and campaign stats are reported
// by UTC day, so its timestamps are displayed in UTC too: read in the viewer's
// zone they stop lining up with the days the agent reasoned about. The local
// reading is a hover away.
export function UtcTimestamp({ date, ...props }: UtcTimestampProps) {
  if (date === null) {
    return <Text {...props}>—</Text>;
  }

  return (
    <Tooltip content={`Local time: ${formatDayTimeWithZone(date)}`}>
      <Text cursor={"help" as any} whiteSpace="nowrap" {...props}>
        {formatDayTime(date, "UTC")}
      </Text>
    </Tooltip>
  );
}
